import { render, staticRenderFns } from "./RegularTables.vue?vue&type=template&id=3f575f50"
import script from "./RegularTables.vue?vue&type=script&lang=js"
export * from "./RegularTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports